import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
  templateUrl: "./editname.component.html",
})
export class EditNameComponent {
  form: FormGroup;

  constructor(private fb: FormBuilder) {}

  createFormWithValues(name: string) {
    this.form = this.fb.group({
      name: [name, [Validators.required, Validators.maxLength(100)]],
    });
  }

  hasErrors(): boolean {
    return this.form.invalid;
  }

  get values(): any {
    return this.form.value;
  }

  get onFormStatusChanges(): Observable<boolean> {
    return this.form.statusChanges.pipe(map(status => status == "INVALID"));
  }
}
